// Dependencies.
import styled, { css } from 'styled-components'
import { useRef, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

import { EventHookInterface } from '../../../types'
import { CTA } from '../../CTA'
import { forScreensGreaterThanMobileWidth, colors } from '../../../utils'

const Div = styled.div`
  position: relative;
  align-items: center;
  background-position: center;
  background-size: cover;
  border: none;
  border-radius: 10px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  outline: none;
  flex-direction: column;

  @media (min-width: 260px) {
    height: 219px;
    width: 219px;
  }

  @media (min-width: 440px) {
    height: 389px;
    width: 389px;
  }

  & .root {
    width: 100%;
    height: 100%;
    align-items: center;
    background-position: center;
    background-size: cover;
    border: none;
    border-radius: 10px;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    outline: none;
    flex-direction: column;

    & .cateIcon {
      background: ${colors.white};
      box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.05);
      font-size: 36px;
      width: 88px;
      height: 88px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    & .coverImage {
      background-color: ${colors.white};
      background-position: center;
      background-size: cover;
      border-radius: 6px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      flex-shrink: 0;
    }
  }
`

// Props.
interface Props {
  eventHook: EventHookInterface
}

// Event Image.
export const EventImage: React.FC<Props> = (props) => {
  // Props.
  const { eventHook } = props
  const { value } = eventHook
  const { category } = value

  const coverImage = value.image_url || value.image

  if (!category) return null
  // ..
  return (
    <Div>
      <div className="root">
        <style jsx>{`
          .root {
            background: ${category && category.background_colour
              ? category.background_colour
              : colors.white};
          }
        `}</style>
        {coverImage && <img className="coverImage" src={coverImage}></img>}
        {!coverImage && (
          <div className="cateIcon">{(category && category.emoji) || ''}</div>
        )}
      </div>
    </Div>
  )
}
